__turbopack_context__.v({
  "active": "userChoicePromptQueue-module__KGSSEG__active",
  "darkOption": "userChoicePromptQueue-module__KGSSEG__darkOption",
  "description": "userChoicePromptQueue-module__KGSSEG__description",
  "dialog": "userChoicePromptQueue-module__KGSSEG__dialog",
  "error": "userChoicePromptQueue-module__KGSSEG__error",
  "icon": "userChoicePromptQueue-module__KGSSEG__icon",
  "iconShell": "userChoicePromptQueue-module__KGSSEG__iconShell",
  "lightOption": "userChoicePromptQueue-module__KGSSEG__lightOption",
  "meta": "userChoicePromptQueue-module__KGSSEG__meta",
  "moon-sway": "userChoicePromptQueue-module__KGSSEG__moon-sway",
  "moonIconShell": "userChoicePromptQueue-module__KGSSEG__moonIconShell",
  "option": "userChoicePromptQueue-module__KGSSEG__option",
  "optionLabel": "userChoicePromptQueue-module__KGSSEG__optionLabel",
  "options": "userChoicePromptQueue-module__KGSSEG__options",
  "panel": "userChoicePromptQueue-module__KGSSEG__panel",
  "queueBadge": "userChoicePromptQueue-module__KGSSEG__queueBadge",
  "sun-wiggle": "userChoicePromptQueue-module__KGSSEG__sun-wiggle",
  "sunIconShell": "userChoicePromptQueue-module__KGSSEG__sunIconShell",
  "title": "userChoicePromptQueue-module__KGSSEG__title",
});
